import { ChangeEvent } from "react";

import { Input } from "baseui/input";

interface TextInputProps {
  readonly placeholder: string;
  readonly id: string;
  readonly value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void; // Updated type
}

function TextInput({
  placeholder = "Text",
  id,
  value,
  onChange
}: TextInputProps) {
  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (onChange) {
      // Asserting the target as HTMLInputElement
      const inputEvent = event as ChangeEvent<HTMLInputElement>;
      onChange(inputEvent);
    }
  };
  return (
    <Input
      type="text"
      id={id}
      value={value}
      onChange={handleChange}
      data-testid={id}
      placeholder={placeholder}
      overrides={{
        Root: {
          style: {
            marginBottom: "1rem"
          }
        }
      }}
    />
  );
}

export default TextInput;
